/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum OpportunityPriorityType {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High'
}
